// extracted by mini-css-extract-plugin
export default {"linkWrapper":"lT8wxwBE0T1NSDKCsumV","fullWidth":"NYzVQZVq4JD6V_jsME6S","borderTop":"l7hmWVdv4QPUsHrBpgiq"};